module.exports = __webpack_public_path__ + "5bcdda2684769a43ac09ec4c3f95f13b.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-warning.svg
// module id = Rq+a
// module chunks = 5